import { P01CREALOGCOL_State } from '@batical/types/src'

const P01CREALOGCOL: P01CREALOGCOL_State = {
  user: '',
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  address: null,
  addressComponents: null,
  calcul_code: 'P01CREALOGCOL',
  projectName: '',
  avancement: '0',
  description: '',
  in_nombreBatiment: 1,
  in_nbProductionECS: 1,
  compilation_uuid: '0',
  in_percentChauffage: 0,
  in_percentECS: 0,
  surpuissance_uuid: 'none',
  surpuissance_percent_uuid: '10',
  in_nbGenerateur: 1,
  batiments: [{ name: 'Batiment 1', in_puissance: 0, chauffage_state: {} }],
  productionECS: [{ name: 'Batiment 1', isPrimaire: false, in_volumeStockage: 0, in_puissance: 0, in_puissanceInstant: 0, ecs_state: {} }],
  res_sommeBesoinChauffage: 0,
  res_sommeBesoinECS: 0,
  res_puissanceChaufferie: 0,
  res_puissnaceUnitaire: 0
}

export default P01CREALOGCOL
